import { z } from 'zod';
import { PRODUCT_UOM_CONVERSION_CONSTRAINTS } from './constraints.js';
export const ratioFormSchema = z.string().superRefine((value, context) => {
    const trimmed = value.trim();
    if (!trimmed) {
        context.addIssue({
            code: 'custom',
            message: `${PRODUCT_UOM_CONVERSION_CONSTRAINTS.ratio.label} is required.`,
            path: [],
        });
        return;
    }
    const parsed = Number(trimmed);
    if (!Number.isFinite(parsed) || parsed <= 0) {
        context.addIssue({
            code: 'custom',
            message: `${PRODUCT_UOM_CONVERSION_CONSTRAINTS.ratio.label} must be greater than 0.`,
            path: [],
        });
        return;
    }
    if (parsed < PRODUCT_UOM_CONVERSION_CONSTRAINTS.ratio.min) {
        context.addIssue({
            code: 'custom',
            message: `${PRODUCT_UOM_CONVERSION_CONSTRAINTS.ratio.label} must be ${PRODUCT_UOM_CONVERSION_CONSTRAINTS.ratio.minMessage} or greater.`,
            path: [],
        });
        return;
    }
    if (parsed > PRODUCT_UOM_CONVERSION_CONSTRAINTS.ratio.max) {
        context.addIssue({
            code: 'custom',
            message: `${PRODUCT_UOM_CONVERSION_CONSTRAINTS.ratio.label} must be 1 billion or less.`,
            path: [],
        });
    }
});
//# sourceMappingURL=ratio-form-schema.js.map